module.exports = __webpack_public_path__ + "img/trash.1148ca34.svg";